import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.array.find.js";
import "regenerator-runtime/runtime.js";
var DuelTabs = function DuelTabs() {
  return import('@/components/organisms/DuelTabs');
};
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
var PrimeIcon = function PrimeIcon() {
  return import('@/components/atoms/PrimeIcon');
};
var ExternalLink = function ExternalLink() {
  return import('@/components/atoms/ExternalLink');
};
import Nl2br from 'vue-nl2br';
var LazyImage = function LazyImage() {
  return import('@/components/atoms/LazyImage');
};
export default {
  components: {
    DuelTabs: DuelTabs,
    PrimeIcon: PrimeIcon,
    ExternalLink: ExternalLink,
    PageTitle: PageTitle,
    Nl2br: Nl2br,
    LazyImage: LazyImage
  },
  data: function data() {
    return {
      isEntried: false,
      userInfos: []
    };
  },
  computed: {
    getShownTitleMatchMasters: function getShownTitleMatchMasters() {
      return useTitleMatchStore().getShownTitleMatchMasters;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.fetchUserInfo();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getTitleMatchName: function getTitleMatchName(titleMatchId) {
      return useTitleMatchMaster().getTitleMatchName(titleMatchId);
    },
    getTitleMatchClass: function getTitleMatchClass(titleMatchId) {
      return useTitleMatchMaster().getTitleMatchClass(titleMatchId);
    },
    getCupPeriodStr: function getCupPeriodStr(period) {
      var sinceStr = this.$dayjs(period.since * 1000).format('LLL');
      var untilStr = this.$dayjs(period.until * 1000).format('LLL');
      return "".concat(sinceStr, " - ").concat(untilStr);
    },
    getIsFinished: function getIsFinished(period) {
      var until = this.$dayjs(period.until * 1000);
      return this.$dayjs().isAfter(until);
    },
    fetchUserInfo: function fetchUserInfo() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this2.getShownTitleMatchMasters.forEach( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(x) {
                  var userInfo;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return _this2.$duelsService.getMyTmUserInfo(x.titleMatchId);
                      case 2:
                        userInfo = _context2.sent;
                        userInfo.titleMatchId = x.titleMatchId;
                        _this2.userInfos.push(userInfo);
                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    clickConfirm: function clickConfirm(id) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!_this3.userInfo(id).isjoined) {
                _context4.next = 5;
                break;
              }
              _context4.next = 3;
              return _this3.$router.push(_this3.localePath({
                name: 'titlematch-titleMatchId-index-users',
                params: {
                  titleMatchId: id
                }
              }));
            case 3:
              _context4.next = 7;
              break;
            case 5:
              _context4.next = 7;
              return _this3.$router.push(_this3.localePath({
                name: 'titlematch-titleMatchId-index-detail',
                params: {
                  titleMatchId: id
                }
              }));
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    isShownIcon: function isShownIcon(titleMatchMaster) {
      return this.userInfo(titleMatchMaster.titleMatchId).isjoined || this.getTitleMatchClass(titleMatchMaster.titleMatchId) || titleMatchMaster.rules.isPrimeOnly;
    },
    userInfo: function userInfo(id) {
      return this.userInfos.find(function (x) {
        return x.titleMatchId == id;
      }) || {};
    }
  }
};